var Config = {
  /** URL */
  // ajaxUrl: "http://guanwang.weileit.com:19111/wlwz",
  ajaxUrl: "https://www.weileit.com/wlwz",//正式环境
};

window.Config = Config;